import { YesObject } from '@yes.technology/react-toolkit'
import { useParams } from 'react-router-dom'
import { SitemodelUuid } from 'sitemodel/shared/types'
import useYesObject from 'yesObject/shared/hooks/useYesObject'

export interface SitemodelObjectState {
  sitemodel: YesObject | undefined
  isLoading: boolean
  isFetched: boolean
}

export default function useSitemodelFromUrl() {
  const { sitemodelUuid: sitemodelUuidInUrl } = useParams<SitemodelUuid>()

  const isSidInUrl = !sitemodelUuidInUrl?.includes('-')

  const {
    yesObject: sitemodelFromUrl,
    isLoading: isLoadingSitemodelFromUrl,
    isFetched: isSiteModelFetched,
    fetchObjects: refetchSitemodelFromUrl
  } = useYesObject({
    objectUUID: isSidInUrl || !sitemodelUuidInUrl ? '' : sitemodelUuidInUrl,
    objectSID: isSidInUrl ? sitemodelUuidInUrl : '',
    objectclassUUID: window.idObjectclassSitemodel,
    showLoading: true,
    displayMessageOnNoItemsFound: false,
    hasActiveSitutation: true
  })

  return {
    sitemodel: sitemodelFromUrl,
    isLoading: isLoadingSitemodelFromUrl,
    isFetched: isSiteModelFetched,
    refetchSitemodelFromUrl
  }
}
